import React, { useState, useEffect } from "react";
import Header from "../../../../Componets/Header";
import Loadercomponent from "../../../../Componets/Loader";
import { Card, Table, Typography, Empty } from "antd";
import { TableOutlined } from "@ant-design/icons";
import trialBalanceService from "../../../../Controllers/Accounting/Services/trialBalanceService";
import dayjs from "dayjs";
import headers from "../../../../Data/Tables/Accounting/ReportEntry/Trailbalance/headers";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
const { Text } = Typography;

const safeToLocaleString = (value) => {
  const num = Number(value) || 0;
  return num.toLocaleString("en-US", {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  });
};

const TrialBalanceReport = () => {
  const [loader, setLoader] = useState(true);
  const [header, setHeader] = useState(headers);
  const [data, setData] = useState([]);
  const [dates, setDates] = useState({});
  const [totals, setTotals] = useState({ totalDebit: 0, totalCredit: 0 });

  const formdata = (Data) => {
    console.log("Form data received:", Data);
    setDates(Data.date);
  };

  const loadData = async () => {
    setLoader(true);
    try {
      const requestData =
        dates.start && dates.end
          ? { startDate: dates.start, endDate: dates.end }
          : {};

      const result = await trialBalanceService.getTrialBalance(requestData);

      if (result.success) {
        setData(result.accounts || []);
        setTotals({
          totalDebit: result.totalDebit || 0,
          totalCredit: result.totalCredit || 0,
        });
      }
    } catch (err) {
      console.error("Error loading Trial Balance:", err);
    } finally {
      setLoader(false);
    }
  };

  const headerReset = () => {
    let componentData = [];
    headers?.components?.map((value, index) => {
      componentData?.push({
        ...value,
        value: null,
      });
    });
    setHeader({ ...headers, components: componentData });
  };

  useEffect(() => {
    loadData();
    headerReset();
  }, []);

  useEffect(() => {
    loadData();
  }, [dates]);

  const columns = [
    {
      title: "Account Name",
      dataIndex: "name",
    },
    {
      title: "Account Type",
      dataIndex: "accountType",
    },
    {
      title: "Debit (OMR)",
      dataIndex: "debit",
      align: "right",
      render: (value) => (
        <Text type="success">{safeToLocaleString(value)}</Text>
      ),
    },
    {
      title: "Credit (OMR)",
      dataIndex: "credit",
      align: "right",
      render: (value) => <Text type="danger">{safeToLocaleString(value)}</Text>,
    },
  ];

  const downloadPDF = () => {
    const pdf = new jsPDF("p", "mm", "a4");

    pdf.setFontSize(18);
    pdf.text("Trial Balance Report", 14, 20);

    if (dates.start && dates.end) {
      pdf.setFontSize(11);
      pdf.text(
        `Period: ${dayjs(dates.start).format("MMM D, YYYY")} - ${dayjs(
          dates.end
        ).format("MMM D, YYYY")}`,
        14,
        30
      );
    }

    autoTable(pdf, {
      startY: 40,
      head: [["Account Name", "Account Type", "Debit (OMR)", "Credit (OMR)"]],
      body: data.map((item) => [
        item.name,
        item.accountType,
        safeToLocaleString(item.debit),
        safeToLocaleString(item.credit),
      ]),
      theme: "grid",
      styles: { fontSize: 10 },
      headStyles: { fillColor: [24, 144, 255] },
    });

    let finalY = pdf.lastAutoTable.finalY + 10;
    pdf.setFontSize(12);
    pdf.text(
      `Total Debit: ${safeToLocaleString(totals.totalDebit)}`,
      14,
      finalY
    );
    pdf.text(
      `Total Credit: ${safeToLocaleString(totals.totalCredit)}`,
      100,
      finalY
    );

    pdf.save("TrialBalanceReport.pdf");
  };

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <div className="flex gap-3 mb-3 justify-end">
        <button
          onClick={downloadPDF}
          className="px-4 py-2 rounded border border-gray-500 text-gray-600 bg-transparent hover:bg-gray-100 active:bg-gray-200 active:scale-95 transition-all duration-100"
        >
          Export as PDF
        </button>
      </div>
      <Loadercomponent loader={loader}>
        <div style={{ padding: 24 }}>
          <Card
            title={
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <TableOutlined />
                <span>Trial Balance Report</span>
              </div>
            }
          >
            {!loader && data.length > 0 ? (
              <>
                <div style={{ marginBottom: 16, textAlign: "center" }}>
                  {dates.start && dates.end
                    ? `Period: ${dayjs(dates.start).format(
                        "MMM D, YYYY"
                      )} - ${dayjs(dates.end).format("MMM D, YYYY")}`
                    : ""}
                </div>

                <Table
                  columns={columns}
                  dataSource={data.map((item, index) => ({
                    key: index,
                    ...item,
                  }))}
                  pagination={false}
                  size="small"
                  style={{ marginBottom: 24 }}
                />

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 32,
                  }}
                >
                  <div>
                    <Text strong>Total Debit:</Text>
                    <br />
                    <Text type="success">
                      {safeToLocaleString(totals.totalDebit)}
                    </Text>
                  </div>
                  <div>
                    <Text strong>Total Credit:</Text>
                    <br />
                    <Text type="danger">
                      {safeToLocaleString(totals.totalCredit)}
                    </Text>
                  </div>
                </div>
              </>
            ) : (
              <Empty
                description={loader ? "Loading report..." : "No data available"}
              />
            )}
          </Card>
        </div>
      </Loadercomponent>
    </Header>
  );
};

export default TrialBalanceReport;
